export default "__VITE_ASSET__vBev5Ofm__"